export default __webpack_public_path__ + "locales/pt/UploadPanel.json?hash=b372e117893c3030a4153629e602971d";